import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
export function WelcomeSection() {
  return <section className="py-20 md:py-32 bg-white relative overflow-hidden" data-id="element-395">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-blue-50 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl opacity-60" data-id="element-396" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-50 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl opacity-60" data-id="element-397" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-398">
        <SectionHeading title="Namaste & Welcome" subtitle="To the land of mountains, spirituality, and endless adventure." data-id="element-399" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="prose prose-lg mx-auto text-gray-600 leading-relaxed" data-id="element-400">
          <p className="mb-6" data-id="element-401">
            At{' '}
            <span className="font-bold text-[#0066FF]" data-id="element-402">Himalayan Trekking</span>
            , we don't just organize trips; we craft life-changing experiences.
            Born from a passion for the high mountains and a deep respect for
            local culture, our agency has been guiding adventurers through the
            rugged trails of Nepal, Tibet, and Bhutan for over a decade.
          </p>
          <p data-id="element-403">
            Whether you dream of standing at the foot of Everest, exploring
            ancient monasteries in Mustang, or finding peace in the lush valleys
            of Annapurna, our team of expert Sherpa guides ensures your journey
            is safe, authentic, and unforgettable. We believe in sustainable
            tourism that empowers local communities and preserves the pristine
            beauty of the Himalayas for generations to come.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-12" data-id="element-404">
          <img src="https://images.unsplash.com/photo-1585938389612-a552a28d6914?q=80&w=2060&auto=format&fit=crop" alt="Signature" className="h-24 mx-auto opacity-80" data-id="element-405" />
          <p className="text-sm text-gray-500 mt-2 font-medium tracking-wide uppercase" data-id="element-406">
            Pemba Sherpa, Founder
          </p>
        </motion.div>
      </div>
    </section>;
}